export class QuestionnaireUser {
  first_name: string;
  last_name: string;
  phone_number: string;
  email_address: string;
  referred_by_code: string;
  marketing_sms_opt_in: boolean = true;
}
